import React from 'react';
import { Link } from 'react-router-dom';

class TableauDemo extends React.Component {

  constructor(props) {
    super(props);
  }

	render() {
		return (
			<div className="animated fadeIn">
        <div className="row">
        <div className="col-md-12 col-xs-12">
          <h3>Tableau de Bord</h3>
          <h5>La puissance des stats</h5>
          <br/>
        </div>
        </div>
        <hr/>

        <div className="row">
        <div className="col-md-12">
					<a href="/userAccount">
					<img className="img-fluid" src="/img/regulier-aut-2019-banner.png" alt="tableau-de-bord" width="1000"/>
					</a>
					<br/><br/>
        </div>
        </div>

        <div className="row">
        <div className="col-md-7">
					<h5>Le Tableau de Bord STATELO vous offre</h5>
					
					<ul className="ul-left-aligned">
						<li>Une analyse efficace, personnalisée et innovatrice de vos statistiques</li>
						<li>Des tableaux et des graphiques représentant vos résultats</li>
						<li>Le résultat de tous vos matchs en un seul lieu</li>
						<li>Toutes vos parties jouées, analysées et comparées aux autres joueurs</li>
						<li>La possibilité de trier et filtrer vos statistiques</li>
						<li>Un outil évolutif qui vous en donnera toujours plus !</li>
					</ul>
	
         	<Link to="/userAccount" className="btn btn-primary"> Je veux m'abonner !</Link>
					<br/><br/>

        </div>
{/*
        <div className="col-md-3 text-center">
					<img className="img-fluid" src={"/img/tb-demo02a.png"} alt={"Analyse-Résultats"} width="300"/>
					<br/><br/>
        </div>
*/}
        <div className="col-md-4 text-center">
					<img className="img-fluid" src="/img/tb-demo01a.png" alt="Mesurer, Comparer, Améliorer" width="200"/>
					<br/><br/>
        </div>

        </div>

        <div className="row">
        <div className="col-md-4 text-center">
					<br/>
{/*
					<h5>Voyez une démonstration vidéo du tableau de bord ici ! <br/> <i>(à venir dans les prochains jours)</i></h5>
					<br/><br/>
*/}
        </div>
        </div>

        <hr/>
        <div className="row">
        <div className="col-md-12">
					<h5>Plusieurs modules de statistiques différents à votre disposition</h5>
					<br/>
        </div>
        </div>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Types de statistiques</b></p>
          <p className="text-justify">Visualisez toutes vos statistiques de parties sous différents angles.  Affichez vos statistiques
          globabalement ou choisissez de voir seulement vos statistiques de Ligue ou de Tournoi.</p>
        </div>
        </div>
        <br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Vos indices de performance</b></p>
          <p className="text-justify">Vos indices de performance actuels représentent sommairement vos statistiques et l'évolution de ces
          dernières lors de la dernière semaine et du dernier mois.  L'Indice de Performance Statelo (IPS) est
          une statistique actuellement en évolution.  Il est calculé à partir de vos performances 
          (victoires, différentiel, ERO, etc) et la formule est gardée secrète actuellement. <br/><br/>
          Et vous, comment s'est passée votre dernière semaine ? </p>

	        <div className="table-responsive">
					<img src={"/img/tb-demo03a.png"} alt={"demo03a"}/>
          </div>
        </div>
        </div>
        <br/><br/>

        <div className="row">
        <div className="col-md-6">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Vos statistiques sommaires</b></p>
          <p className="text-justify">Vos statistiques sommaires vous présentent une compilation de toutes les parties 
          que vous jouées à vie (dans Statelo) ainsi que vos statistiques du dernier mois et de la dernière semaine. <br/><br/>
          Et vous, avez-vous plus de victoires que de défaites pendant le dernier mois ?</p>

          <div className="table-responsive">
					<img src={"/img/tb-demo04a.png"} alt={"demo04a"}/>
          </div>
        </div>

        <div className="col-md-6">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Vos performances cumulées</b></p>
          <p className="text-justify">Vos performances cumulées vous affichent vos eros et vos tables vidées à vie (dans Statelo), 
          ainsi que ces performances lors du dernier mois et de la dernière semaine. <br/><br/>
          Et vous, combien de ERO contre avez-vous subi la dernière semaine ?</p>

	        <div className="table-responsive">
					<img src={"/img/tb-demo04b.png"} alt={"demo04b"}/>
          </div>
	      </div>
	      </div>
	      <br/><br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Un graphique de votre évolution</b></p>
          <p className="text-justify">Ce graphique représente votre évolution de façon très dynamique.  Vous pouvez choisir la période 
          d'analyse qui vous intéresse (Date de début et Date de fin), ainsi que le type de statistiques à 
          représenter (Moyenne, IPS, % de victoires) et la période d'analyse (mois, semaine, jour).  Encore plus
          intéressant, il est possible de choisir un adversaire et de comparer votre évolution avec ce dernier.
          Dans le graphique suivant, on voit bien que Wayne est plus constant que Mario et avait un meilleur
          début de saison en 2017, par contre, Mario a connu des très grosses semaines en fin de saison 2017 et
          à l'automne 2018... Avec tous ces choix, les possibilités d'analyse sont infinies !  <br/><br/>
          Et vous, avez-vous maintenu une moyenne plus élevée que votre adversaire favori durant la saison ?</p>

          <div className="table-responsive">
					<img src={"/img/tb-demo05a.png"} alt={"demo05a"}/>
          </div>

        </div>
        </div>
        <br/><br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Le résultat de tous vos matchs</b></p>
          <p className="text-justify">On trouve dans ce tableau tous les matchs joués au cours des semaines.
          La meilleure façon de visualiser vos performances de soirées de ligues ou vos matchs de tournoi.
          Vous pouvez aussi évidemment trier toutes ces données par catégorie. <br/><br/>
          Et vous, quelle est votre meilleure semaine de ligue à vie ? </p>

          <div className="table-responsive">
					<img src={"/img/tb-demo09a.png"} alt={"demo09a"}/>
          </div>

        </div>
        </div>
        <br/><br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Toutes vos parties jouées</b></p>
          <p className="text-justify">Ce tableau parle de lui-même.  On y trouve toutes les parties que vous avez jouées dans une ligue ou un tournoi 
          dont Statelo a compilé les statistiques.  Les parties sont groupées par page pour un meilleur visionnement.
          Il est aussi possible de trier les parties jouées en cliquant sur les entêtes de colonne. <br/><br/>
          Et vous, êtes-vous satisfait de vos dernières parties ? </p>

          <div className="table-responsive">
					<img src={"/img/tb-demo06a.png"} alt={"demo06a"}/>
          </div>

        </div>
        </div>
        <br/><br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Tous vos affrontements par adversaire</b></p>
          <p className="text-justify">Le tableau suivant vous offre une compilation de vos statistiques groupées par adversaire.  En filtrant 
          par minimum de parties jouées, vous pouvez facilement découvrir votre bête noire ou votre adversaire préféré
          et penser à vos prochains matchs contre ces derniers !   <br/><br/>
          Et vous, selon vous, qui est votre bête noire ?</p>

          <div className="table-responsive">
					<img src={"/img/tb-demo07a.png"} alt={"demo07a"}/>
          </div>
        </div>
        </div>
        <br/><br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Un comparatif de vos adversaires</b></p>
          <p className="text-justify">Cet outil vous permet de choisir jusqu'à adversaires afin d'afficher efficacement votre fiche contre 
          ces derniers.  Inscrivez rapidement vos 4 prochains adversaires et découvrez, avec surprise, que vous
          devriez avoir une meilleure fiche contre deux de ceux-ci!  <br/><br/>
          Et vous, vous pensez avoir une fiche gagnante contre vos prochains adversaires ? </p>

          <div className="table-responsive">
					<img src={"/img/tb-demo08a.png"} alt={"demo08"}/>
          </div>
        </div>
        </div>
        <br/><br/>

        <div className="row">
        <div className="col-md-12">
					<p><span className="icon-control-forward"></span> &nbsp; <b>Et encore plus à venir … !</b></p>
					<p className="text-justify">
					Toutes ces statistiques et toute cette analyse à un coût équivalent à une partie de billard par semaine (1,50$) seulement!
					</p>
					<p className="text-justify">
					STATELO travaille sans relâche pour créer encore plus de modules de statistiques, 
					et ainsi vous permettre de mieux vous guider lors de votre pratique et lors de vos matchs !<br/>
					</p>
        </div>
        </div>

        <div className="row">
        <div className="col-md-12">
        	<Link to="/userAccount" className="btn btn-primary"> Je veux m'abonner !</Link>
        </div>
        </div>

        <br/><br/>
        <br/><br/>

      </div>
		);
	}

}

export default TableauDemo;